import React from "react";

const PageTitle = ({ motherMenu, activeMenu, pageContent }) => {
 return null;
};

export default PageTitle;
